// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsRdsDbInstancesIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-rds-db-instances_svga)" d="M40 0H0v40h40z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M11.85 28.85 7.71 33h2.79v1h-4a.5.5 0 0 1-.5-.5v-4h1v2.8l4.15-4.15zM33 29.5h1v4a.5.5 0 0 1-.5.5h-4v-1h2.8l-4.15-4.15.7-.7L33 32.29zm1-23v4h-1V7.7l-4.15 4.15-.7-.7L32.29 7H29.5V6h4c.28 0 .5.22.5.5m-27 4H6v-4c0-.28.22-.5.5-.5h4v1H7.53l4.32 4.14-.7.72L7 7.88zm25.73 8.9c0-1.56-1.81-3.1-4.83-4.12l.32-.95c3.5 1.19 5.5 3.03 5.5 5.07s-2 3.89-5.5 5.07l-.32-.95c3.02-1.02 4.83-2.56 4.83-4.12m-25 0c0 1.5 1.7 3 4.53 4.01l-.34.94c-3.3-1.18-5.18-2.99-5.18-4.95s1.88-3.77 5.18-4.95l.34.94C9.43 16.4 7.74 17.9 7.74 19.4m12.3-3.68c-3.14 0-4.9-.8-4.92-1.13.02-.32 1.78-1.12 4.91-1.12 3.14 0 4.9.8 4.92 1.12-.03.33-1.78 1.13-4.92 1.13m0 3.55c-3.19 0-4.92-.92-4.92-1.4v-2.03c1.13.6 3.07.88 4.91.88s3.79-.28 4.92-.88v2.03c0 .48-1.74 1.4-4.92 1.4m0 3.74c-3.19 0-4.92-.93-4.92-1.4v-2.34c1.12.66 3.02 1 4.91 1s3.8-.34 4.92-1v2.34c0 .47-1.74 1.4-4.92 1.4m0 3.28c-3.19 0-4.92-.91-4.92-1.38V23c1.12.66 3.02 1 4.91 1s3.8-.34 4.92-1v1.9c0 .46-1.74 1.38-4.92 1.38m0-13.82c-2.86 0-5.92.66-5.92 2.12v10.32c0 1.56 2.97 2.38 5.91 2.38s5.92-.82 5.92-2.38V14.59c0-1.46-3.07-2.12-5.92-2.12"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="aws-rds-db-instances_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsRdsDbInstances",
);
export default AwsRdsDbInstancesIcon;
